export var IssueType;
(function (IssueType) {
    IssueType["ISSUE_TYPE_UNSPECIFIED"] = "ISSUE_TYPE_UNSPECIFIED";
    IssueType["ISSUE_TYPE_LAST_SNAPSHOT_PARTIAL"] = "LAST_SNAPSHOT_PARTIAL";
})(IssueType || (IssueType = {}));
